module.exports = __webpack_public_path__ + "static/media/loades-eco-park-2.441f6bef.jpg";